import { useEffect } from 'react';
import { googleAnalyticsConfig } from '../config';

// ----------------------------------------------------------------------

const GA_MEASUREMENT_ID = googleAnalyticsConfig;
const SCRIPT_ID = 'ga-gtag';

// Google Analytics loader (card 223).
//
// TWO separate reasons this has never run in production, both addressed here:
//
// 1. It rendered its tags through react-helmet-async, which emits nothing at
//    all in this app — so the gtag script was never in the document and
//    `window.gtag` was undefined on every page load. `utils/analytics.js`
//    guards on `window.gtag`, so every pageview and event call has been a
//    silent no-op rather than a visible error.
//
// 2. REACT_APP_GA_MEASUREMENT_ID is not set — not in .env, not in example.env.
//    Without it the old code would have requested `gtag/js?id=undefined`.
//
// So the script is injected imperatively now, and gated on a real measurement
// id. With no id configured this renders nothing and stays silent, which is the
// honest behaviour: analytics that cannot work should not pretend to.
//
// NOTE Lucky Orange is loaded separately as a static tag in public/index.html
// and DOES work — `utils/onboardingAnalytics.js` uses it. It is the instrument
// to reach for while GA has no measurement id.

export default function GoogleAnalytics() {
  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    // Idempotent: a remount must not append a second gtag script.
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // dataLayer must exist and gtag must be callable BEFORE the remote script
    // finishes loading, or every call made in that window is lost.
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
    }
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  }, []);

  return null;
}
